var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconUtilityWater40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_11084)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0027 27.5029C31.5933 29.2434 32.5339 30.5694 32.8246 31.4807C33.2606 32.8477 32.8773 34.0234 31.7467 34.8602C30.6162 35.6969 29.4437 35.7372 28.2587 34.8602C27.0737 33.9831 26.7529 32.8225 27.1808 31.4807C27.4661 30.5862 28.4068 29.2603 30.0027 27.5029Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12.5029V8.50293H18V12.5029",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12.5029V8.50293H18V12.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3529 5.50293H14.6471C13.7374 5.50293 13 6.1745 13 7.00293C13 7.83136 13.7374 8.50293 14.6471 8.50293H25.3529C26.2626 8.50293 27 7.83136 27 7.00293C27 6.1745 26.2626 5.50293 25.3529 5.50293Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5046 12.3682H5V19.09H26.2321V22.5032H34V14.7362C34 13.4284 32.8863 12.3682 31.5125 12.3682H26.5046Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3333 22.5029H25.6667C25.2985 22.5029 25 22.8611 25 23.3029V24.7029C25 25.1448 25.2985 25.5029 25.6667 25.5029H34.3333C34.7015 25.5029 35 25.1448 35 24.7029V23.3029C35 22.8611 34.7015 22.5029 34.3333 22.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_11084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconUtilityWater40);
export default __webpack_public_path__ + "static/media/pictogramBeaconUtilityWater40.747524ea5c27f9080691ffdde38ba65f.svg";
export { ForwardRef as ReactComponent };